var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-pills"},[_c('ul',{staticClass:"space-pills--list"},_vm._l((_vm.data),function(item,i){return _c('li',{key:i},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }